import { Head } from '@inertiajs/react';
import { Building, Mail, Phone, FileText } from 'lucide-react';

export default function MentionsLegales() {
  return (
    <>
      <Head title="Mentions légales - Ethos Santé" />
      
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* En-tête */}
          <div className="mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Mentions légales
            </h1>
            <p className="text-lg text-gray-600">
              Informations légales relatives au site Ethos Santé
            </p>
          </div>

          {/* Éditeur du site */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-[#008788]/10 rounded-full mr-3">
                <Building className="h-6 w-6 text-[#008788]" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Éditeur du site
              </h2>
            </div>
            <div className="space-y-3 text-gray-700">
              <p>
                <strong>Identité de l'Éditeur du site :</strong> JCF Santé, SAS immatriculée au R.C.S de Chambéry sous le numéro 943 132 050
              </p>
              <p>
                <strong>Siège social :</strong> 15 rue du Père Roger Guichardan 73 000 Chambéry
              </p>
              <p>
                <strong>Numéro de téléphone :</strong> 0458141597
              </p>
              <p>
                <strong>Courrier électronique :</strong> <a href="mailto:ethosante@gmail.com" className="text-[#008788] hover:text-[#00bcbe]">ethosante@gmail.com</a>
              </p>
              <p>
                <strong>Numéro de TVA intracommunautaire :</strong> FR54803600006
              </p>
            </div>
          </div>

          {/* Directeur de publication */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-[#008788]/10 rounded-full mr-3">
                <FileText className="h-6 w-6 text-[#008788]" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Directeur de publication
              </h2>
            </div>
            <p className="text-gray-700">
              Jorane CHARTIER-FOUQUET
            </p>
          </div>

          {/* Contact */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-[#008788]/10 rounded-full mr-3">
                <Mail className="h-6 w-6 text-[#008788]" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Contact
              </h2>
            </div>
            <div className="space-y-3 text-gray-700">
              <p className="flex items-center">
                <Mail className="h-5 w-5 text-[#008788] mr-2" />
                <a href="mailto:contact@ethosante.fr" className="text-[#008788] hover:text-[#00bcbe]">
                  contact@ethosante.fr
                </a>
              </p>
              <p className="flex items-center">
                <Phone className="h-5 w-5 text-[#008788] mr-2" />
                <a href="tel:+33458141597" className="text-[#008788] hover:text-[#00bcbe]">
                  04 58 14 15 97
                </a>
              </p>
            </div>
          </div>

          {/* Hébergeur */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-[#008788]/10 rounded-full mr-3">
                <Building className="h-6 w-6 text-[#008788]" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Hébergeur
              </h2>
            </div>
            <div className="space-y-3 text-gray-700">
              <p>
                <strong>Raison sociale :</strong> Heroku Inc.
              </p>
              <p>
                <strong>Société immatriculée au registre du commerce et des sociétés des Etats Unis sous le numéro :</strong> 602947331
              </p>
              <p>
                <strong>Siège social :</strong> 650 7th Street, San Francisco, CA
              </p>
              <p>
                <strong>Numéro de téléphone :</strong> +1 (877) 563-4311
              </p>
            </div>
          </div>

          {/* Propriété intellectuelle */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Propriété intellectuelle
            </h2>
            <div className="prose prose-gray max-w-none text-gray-700">
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique ou autre quel qu'il 
                soit est formellement interdite sauf autorisation expresse du directeur de publication.
              </p>
            </div>
          </div>

          {/* Données personnelles */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Protection des données personnelles
            </h2>
            <div className="prose prose-gray max-w-none text-gray-700">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique 
                et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition 
                aux données personnelles vous concernant.
              </p>
              <p>
                Pour exercer ces droits ou pour toute question relative à la protection de vos données personnelles, 
                vous pouvez nous contacter à l'adresse : <a href="mailto:contact@ethosante.fr" className="text-[#008788] hover:text-[#00bcbe]">contact@ethosante.fr</a>
              </p>
              <p>
                Pour plus d'informations, consultez notre{' '}
                <a href="/rgpd" className="text-[#008788] hover:text-[#00bcbe]">
                  politique de confidentialité
                </a>.
              </p>
            </div>
          </div>

          {/* Cookies */}
          <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Cookies
            </h2>
            <div className="prose prose-gray max-w-none text-gray-700">
              <p>
                Ce site utilise des cookies pour améliorer votre expérience de navigation et réaliser des 
                statistiques de visites. En poursuivant votre navigation sur ce site, vous acceptez l'utilisation 
                de cookies.
              </p>
            </div>
          </div>

          {/* Avertissement */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 mb-8">
            <p className="text-sm text-yellow-800">
              <strong>Note :</strong> Cette page de mentions légales contient des sections à compléter. 
              Veuillez contacter l'équipe Ethos Santé pour obtenir les informations complètes et à jour.
            </p>
          </div>

          {/* Date de mise à jour */}
          <div className="text-center text-sm text-gray-500">
            <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>
      </div>
    </>
  );
}



